import { inject, Injectable } from '@angular/core';
import { Rolle } from '../rolle.model';
import { RolleRettighedApi } from '@features/roller/rolle-rettigheder/rolle-rettigheder.api';
import { RolleDatasource } from '@features/roller/rolle.datasource';

@Injectable({
  providedIn: 'root',
})
export class RolleDetailService {
  datasource = inject(RolleDatasource);
  rolleRettighedApi = inject(RolleRettighedApi);

  changes: Record<string, any> = {};

  async saveRolle(id: number, newData: Rolle) {
    let rolle: Rolle;
    if (id > 0) {
      rolle = await this.datasource.update(id, newData);
    } else {
      rolle = await this.datasource.create(newData);
    }
    return rolle;
  }

  saveRolleRettigheder(rolleId: number) {
    const promises = [];
    for (const [rettighed, change] of Object.entries(this.changes)) {
      if (change.action === 'remove') {
        promises.push(this.rolleRettighedApi.remove(change.id));
      }
      if (change.action === 'add') {
        promises.push(
          this.rolleRettighedApi.create({
            rolleId: rolleId,
            rettighed: rettighed,
          })
        );
      }
    }
    this.changes = [];
    return Promise.all(promises);
  }
}
